import { carouselItems } from "@/mocks/homeData";

export default function CarouselSection() {
  return (
    <section id="carousel" className="px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
            专题精选
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            按题材分类发现好剧，总有一款适合你
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <div
              key={item.id}
              className="group relative rounded-lg overflow-hidden border border-background-200/60 bg-background-100 cursor-pointer"
            >
              <div className="aspect-[2/1] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="text-[11px] font-medium text-primary-300 bg-black/40 px-2 py-0.5 rounded whitespace-nowrap">
                  {item.subtitle}
                </span>
                <h3 className="mt-2 text-lg md:text-xl font-bold font-heading text-white whitespace-nowrap">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-xs md:text-sm text-white/75 line-clamp-2 leading-relaxed max-w-[500px]">
                  {item.desc}
                </p>
                <span className="inline-flex items-center gap-1 mt-3 text-xs text-primary-300 font-medium whitespace-nowrap">
                  立即探索
                  <i className="ri-arrow-right-line" />
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}